<template>
  <div>
    <div id="locationForm" class="bg-white rounded px-1">
      <div v-if="locations.length > 0">
        <div class="py-3 px-1 pl-c-xl">
          <icon-view
            icon="fas fa-info-circle"
            icon-background="transparent"
            icon-color="#FF7058"
            icon-size="1.0625rem"
            title="Localidad(es)"
            variant="custom-icon"
          />
          <custom-callout
            v-for="item in locations"
            :key="`location-${item.id}`"
            :border-color="'secondary-2'"
            class="m-2"
            class-main="rounded"
            :controlled="!isInEditMode"
            :has-toggle="hasLocationToggle"
            :opened="item.isOpened && !isInEditMode"
            @click:open="toggle(item)"
          >
            <div class="row py-2 align-items-center justify-content-between">
              <div
                class="row divider align-items-center flex-nowrap col-md-9 col-sm-12"
              >
                <div class="dot text-center">
                  <i class="title-icon fas fa-map-marker-alt" />
                </div>
                <div class="col-12">
                  <div class="color-gray-6 font-14">
                    Dirección Física:
                  </div>
                  <div class="color-black font-16 text-truncate ">
                    {{ getLocationDescription(item) }}
                  </div>
                </div>
              </div>

              <div
                v-if="!isInEditMode && canChangeLocations()"
                class="col-md-3 col-sm-12 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
              >
                <action-button
                  class="btn-action-size"
                  i="fas fa-times-circle pl-1"
                  variant="outline-danger mr-2 pl-1 pt-1"
                  @click="onDeleteLocation(item)"
                />
                <action-button
                  class="btn-action-size"
                  i="fas fa-edit pl-1"
                  variant="success pl-1 pt-1 mr-2"
                  @click="initEditMode(item)"
                />
                <drop-down
                  v-if="isUniquePermissionDocumentsEnabled"
                  class="mr-3 align-vertical-center action-dropdown-background"
                  :items="
                    actionItems(
                      item.photosDocument?.id,
                      item.permissionUniqueDocument?.id
                    )
                  "
                  title="Acciones"
                  variant="standard"
                />
                <action-button
                  v-if="
                    !isUniquePermissionDocumentsEnabled &&
                      item.photosDocument?.id
                  "
                  id="btn-download-document"
                  class="btn-action-size"
                  i="fas fa-file-download"
                  variant="success"
                  @click="() => onDownloadFile(item.photosDocument?.id)"
                />
              </div>
              <div
                v-if="
                  (isSubmitted() || isReplacementRequest()) &&
                    !canChangeLocations()
                "
                class="col-md-3 col-sm-12 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
              >
                <template v-if="isUniquePermissionDocumentsEnabled">
                  <drop-down
                    class="mr-3 align-vertical-center action-dropdown-background"
                    :items="
                      actionItems(
                        item.photosDocument?.id,
                        item.permissionUniqueDocument?.id
                      )
                    "
                    title="Acciones"
                    variant="standard"
                  />
                </template>
                <template v-else>
                  <action-button
                    v-if="item.photosDocument?.id"
                    id="btn-download-document"
                    class="btn-action-size"
                    i="fas fa-file-download"
                    variant="success"
                    @click="() => onDownloadFile(item.photosDocument?.id)"
                  />
                </template>
              </div>
            </div>
            <template #edition>
              <div class="p-3">
                <div class="bg-white p-2 rounded">
                  <icon-view
                    icon="fas fa-file"
                    icon-background="transparent"
                    icon-color="#FF7058"
                    icon-size="1.0625rem"
                    title="Documentos Anejados"
                    variant="custom-icon"
                  />
                  <custom-callout
                    v-if="item.photoIntExtHistory.length > 0"
                    :key="`location-1`"
                    :border-color="'secondary-2'"
                    class="m-2"
                    class-main="rounded"
                    :controlled="!isInEditMode"
                    :has-toggle="hasLocationToggle"
                    :opened="isOpenedPhotoIntExtHistory && !isInEditMode"
                    @click:open="
                      togglePhotoIntExtHistory(isOpenedPhotoIntExtHistory)
                    "
                  >
                    <div class="mx-2">
                      <div
                        class="p-3 my-2 rounded d-flex align-items-center justify-content-between bg-secondary-3 "
                      >
                        <div>
                          <div class="color-gray-6 font-14">
                            Tipo de Documento:
                          </div>
                          <div class="color-black font-16 text-truncate ">
                            Fotos Interior y Exterior
                          </div>
                        </div>
                        <div>
                          <action-button
                            class="btn-action-size"
                            :disabled="!item.photosDocument"
                            i="fas fa-file-download"
                            variant="success"
                            @click="
                              () => onDownloadFile(item.photosDocument.id)
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <template #edition>
                      <time-line class="mt-4 px-4 header-bg">
                        <div
                          v-for="(photoIntExtHistory,
                          index) in item.photoIntExtHistory"
                          :key="`item-index-${index}`"
                        >
                          <time-line-item
                            icon="fas fa-file d-flex justify-content-center align-items-center mx-2"
                          >
                            <template #date>
                              <label
                                class="history-date-title d-flex justify-content-end"
                              >
                                Fecha
                              </label>
                              <label class="history-date-value">
                                {{
                                  $formatDate(photoIntExtHistory.dateOfAction)
                                }}
                                {{
                                  $formatDate(
                                    photoIntExtHistory.dateOfAction,
                                    $templateDate.hour
                                  )
                                }}
                              </label>
                            </template>
                            <div class="mx-2">
                              <div
                                class="rounded d-flex align-items-center justify-content-between bg-secondary-3 "
                              >
                                <div>
                                  <div class="color-gray-6 font-14">
                                    Tipo de Documento:
                                  </div>
                                  <div
                                    class="color-black font-16 text-truncate "
                                  >
                                    Fotos Interior y Exterior
                                  </div>
                                </div>
                                <div>
                                  <action-button
                                    class="btn-action-size"
                                    :disabled="!photoIntExtHistory.photosFileId"
                                    i="fas fa-file-download"
                                    variant="success"
                                    @click="
                                      () =>
                                        onDownloadFile(
                                          photoIntExtHistory.photosFileId
                                        )
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </time-line-item>
                        </div>
                      </time-line>
                    </template>
                  </custom-callout>
                  <div v-else class="mx-2">
                    <div
                      class="p-3 my-2 rounded d-flex align-items-center justify-content-between bg-secondary-3 "
                    >
                      <div>
                        <div class="color-gray-6 font-14">
                          Tipo de Documento:
                        </div>
                        <div class="color-black font-16 text-truncate ">
                          Fotos Interior y Exterior
                        </div>
                      </div>
                      <div>
                        <action-button
                          class="btn-action-size"
                          :disabled="!item.photosDocument"
                          i="fas fa-file-download"
                          variant="success mr-3"
                          @click="() => onDownloadFile(item.photosDocument.id)"
                        />
                      </div>
                    </div>
                  </div>
                  <custom-callout
                    v-if="
                      item.permissionUniqueDocumentHistory.length > 0 &&
                        allowPermissionUnique &&
                        isUniquePermissionDocumentsEnabled
                    "
                    :key="`location-1`"
                    :border-color="'secondary-2'"
                    class="m-2"
                    class-main="rounded"
                    :controlled="!isInEditMode"
                    :has-toggle="hasLocationToggle"
                    :opened="isOpenedPermissionUniqueHistory && !isInEditMode"
                    @click:open="
                      togglePermissionUniqueDocumentHistory(
                        isOpenedPermissionUniqueHistory
                      )
                    "
                  >
                    <div class="mx-2">
                      <div
                        class="p-3 my-2 rounded d-flex align-items-center justify-content-between bg-secondary-3"
                      >
                        <div>
                          <div class="color-gray-6 font-14">
                            Tipo de Documento:
                          </div>
                          <div class="color-black font-16 text-truncate ">
                            Permiso Único
                          </div>
                        </div>
                        <div>
                          <div class="color-gray-6 font-14">
                            Fecha de Vencimiento:
                          </div>
                          <div class="color-black font-16 text-truncate">
                            {{ item.permissionUniqueDueDate | date | empty }}
                          </div>
                        </div>
                        <div>
                          <div class="color-gray-6 font-14">
                            Fecha del Último Estatus:
                          </div>
                          <div class="color-black font-16 text-truncate">
                            {{
                              item.permissionUniqueLastStatusDate | date | empty
                            }}
                          </div>
                        </div>
                        <div>
                          <action-button
                            class="btn-action-size"
                            :disabled="!item.permissionUniqueDocument"
                            i="fas fa-file-download"
                            variant="success"
                            @click="
                              () =>
                                onDownloadFile(item.permissionUniqueDocument.id)
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <template #edition>
                      <time-line class="mt-4 px-4 header-bg">
                        <div
                          v-for="(permissionUniqueDocumentHistory,
                          index) in item.permissionUniqueDocumentHistory"
                          :key="`item-index-${index}`"
                        >
                          <time-line-item
                            icon="fas fa-file d-flex justify-content-center align-items-center mx-2"
                          >
                            <template #date>
                              <label
                                class="history-date-title d-flex justify-content-end"
                              >
                                Fecha
                              </label>
                              <label class="history-date-value">
                                {{
                                  $formatDate(
                                    permissionUniqueDocumentHistory.dateOfAction
                                  )
                                }}
                                {{
                                  $formatDate(
                                    permissionUniqueDocumentHistory.dateOfAction,
                                    $templateDate.hour
                                  )
                                }}
                              </label>
                            </template>
                            <div class="mx-2">
                              <div
                                class="rounded d-flex align-items-center justify-content-between bg-secondary-3 "
                              >
                                <div>
                                  <div class="color-gray-6 font-14">
                                    Tipo de Documento:
                                  </div>
                                  <div
                                    class="color-black font-16 text-truncate "
                                  >
                                    Permiso Único
                                  </div>
                                </div>
                                <div>
                                  <div class="color-gray-6 font-14">
                                    Fecha de Vencimiento:
                                  </div>
                                  <div
                                    class="color-black font-16 text-truncate"
                                  >
                                    {{
                                      permissionUniqueDocumentHistory.permissionUniqueDueDate
                                        | date
                                        | empty
                                    }}
                                  </div>
                                </div>
                                <div>
                                  <action-button
                                    class="btn-action-size"
                                    :disabled="
                                      !permissionUniqueDocumentHistory.permissionUniqueFileId
                                    "
                                    i="fas fa-file-download"
                                    variant="success"
                                    @click="
                                      () =>
                                        onDownloadFile(
                                          permissionUniqueDocumentHistory.permissionUniqueFileId
                                        )
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </time-line-item>
                        </div>
                      </time-line>
                    </template>
                  </custom-callout>
                  <div v-else class="mx-2">
                    <div
                      v-if="
                        allowPermissionUnique &&
                          isUniquePermissionDocumentsEnabled
                      "
                      class="p-3 my-3 rounded d-flex align-items-center justify-content-between bg-secondary-3"
                    >
                      <div>
                        <div class="color-gray-6 font-14">
                          Tipo de Documento:
                        </div>
                        <div class="color-black font-16 text-truncate">
                          Permiso Único
                        </div>
                      </div>
                      <div>
                        <div class="color-gray-6 font-14">
                          Fecha de Vencimiento:
                        </div>
                        <div class="color-black font-16 text-truncate">
                          {{ item.permissionUniqueDueDate | date | empty }}
                        </div>
                      </div>
                      <div>
                        <div class="color-gray-6 font-14">
                          Fecha del Último Estatus:
                        </div>
                        <div class="color-black font-16 text-truncate">
                          {{
                            item.permissionUniqueLastStatusDate | date | empty
                          }}
                        </div>
                      </div>
                      <div>
                        <action-button
                          class="btn-action-size"
                          :disabled="!item.permissionUniqueDocument"
                          i="fas fa-file-download"
                          variant="success mr-3"
                          @click="
                            () =>
                              onDownloadFile(item.permissionUniqueDocument.id)
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </custom-callout>
        </div>
      </div>
      <div v-if="isInEditMode" class="additional-container">
        <div class="py-3 px-1 pl-c-xl">
          <icon-view
            icon="fas fa-info-circle"
            icon-background="transparent"
            icon-color="#FF7058"
            icon-size="1.0625rem"
            :title="(model.id === 0 ? 'Añadir' : 'Editar') + ' Localidad'"
            variant="custom-icon"
          />
        </div>
        <validation-observer ref="locationValidationObserver">
          <div class="mx-3">
            <div class="row">
              <div class="col-md-6 col-sm-12 mr-md">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="address-line-1-input"
                    v-model="model.addressLine1"
                    class="custom-input-con"
                    custom-error-msg="La dirección (línea 1) es requerida."
                    :error="errors[0]"
                    label="Dirección (linea 1):"
                  />
                </validation-provider>
              </div>
              <div class="col-md-6 col-sm-12 mr-md">
                <custom-input
                  id="address-line-2-input"
                  v-model="model.addressLine2"
                  class="custom-input-con"
                  label="Dirección (linea 2):"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 col-sm-12 mr-md">
                <validation-provider
                  v-slot="{ errors }"
                  name="customDropDownState"
                  rules="required"
                >
                  <custom-drop-down
                    id="state-dropdown"
                    v-model="selectedState"
                    :clearable="false"
                    custom-error-msg="El estado es requerido."
                    :error="errors[0]"
                    fieldkey="value"
                    fieldname="state"
                    label="Estado:"
                    :on-selection-change="clearSelectedMunicipality"
                    :options="statesOptions"
                    placeholder="Seleccione el estado"
                  />
                </validation-provider>
              </div>
              <div class="col-md-3 col-sm-12 mr-md">
                <validation-provider
                  v-slot="{ errors }"
                  name="customDropDownMunicipality"
                  :rules="isPRSelected() ? 'required' : ''"
                >
                  <custom-drop-down
                    v-model="selectedMunicipality"
                    :clearable="false"
                    custom-error-msg="Favor seleccionar al menos un Municipio."
                    :disabled="!isPRSelected()"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Municipio:"
                    :options="municipalityOptions"
                    placeholder="Seleccione el municipio"
                  />
                </validation-provider>
              </div>
              <div class="col-md-6 col-sm-12 mr-md">
                <validation-provider v-slot="{ errors }" :rules="'required'">
                  <custom-input
                    id="postal-code-input"
                    v-model="model.providerZipCode"
                    class="custom-input-con"
                    custom-error-msg="El código postal es requerido."
                    :error="errors[0]"
                    label="Código postal:"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="mt-3">
              <div class="bg-white rounded">
                <icon-view
                  v-if="!isUniquePermissionDocumentsEnabled"
                  icon="fas fa-file"
                  icon-background="transparent"
                  icon-color="#FF7058"
                  icon-size="1.0625rem"
                  title="Documentos"
                  variant="custom-icon"
                />
                <div v-else>
                  <label class="data-title mb-0">
                    Fotos interior y exterior:
                  </label>
                </div>
                <div
                  :class="{
                    'mx-0': !isUniquePermissionDocumentsEnabled,
                    'mx-2': isUniquePermissionDocumentsEnabled,
                  }"
                >
                  <div
                    class="p-3  my-2 rounded d-flex align-items-center  bg-secondary-3"
                    :class="{
                      'justify-content-center': !isUniquePermissionDocumentsEnabled,
                      'justify-content-between': isUniquePermissionDocumentsEnabled,
                    }"
                  >
                    <div v-if="isUniquePermissionDocumentsEnabled">
                      <div class="color-gray-6 font-14">
                        Tipo de Documento:
                      </div>
                      <div class="color-black font-16 text-truncate">
                        Fotos Interior y Exterior
                      </div>
                    </div>
                    <div>
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="model.photosDocument ? '' : 'required'"
                      >
                        <custom-file-input
                          ref="photoFileUpload"
                          accept="pdf"
                          add-text="Presione para cargar documento"
                          :attachment-id="model.photosDocument?.id"
                          custom-error-msg="El documento es requerido."
                          display-style="normal"
                          :error="errors[0]"
                          :name="
                            model.photosFile?.filename ||
                              model.photosDocument?.name
                          "
                          :on-download="onDownloadFile"
                          :value="model.photosFile"
                          @input="changePhotosFile"
                        />
                      </validation-provider>
                    </div>
                  </div>
                  <div
                    v-if="
                      allowPermissionUnique &&
                        isUniquePermissionDocumentsEnabled
                    "
                    class="p-3 my-3 rounded d-flex align-items-center justify-content-between bg-secondary-3"
                  >
                    <div>
                      <div class="color-gray-6 font-14">
                        Tipo de Documento:
                      </div>
                      <div class="color-black font-16 text-truncate">
                        Permiso Único
                      </div>
                    </div>
                    <div>
                      <div class="color-gray-6 font-14">
                        Fecha de Vencimiento:
                      </div>
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-date-picker
                          id="permissionUniqueDueDate"
                          v-model="model.permissionUniqueDueDate"
                          class-container="w-100"
                          custom-error-msg="La fecha de término es requerida."
                          :error="errors[0]"
                          format="dd/MMM./yyyy"
                          :min-date="currentDate"
                          placeholder="dd/MMM./yyyy"
                        />
                      </validation-provider>
                    </div>
                    <div>
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="
                          model.permissionUniqueDocument ? '' : 'required'
                        "
                      >
                        <custom-file-input
                          ref="permissionUniqueFileUpload"
                          accept="pdf"
                          add-text="Presione para cargar documento"
                          :attachment-id="model.permissionUniqueDocument?.id"
                          custom-error-msg="El documento es requerido."
                          display-style="normal"
                          :error="errors[0]"
                          :name="
                            model.permissionUniqueFile?.filename ||
                              model.permissionUniqueDocument?.name
                          "
                          :on-download="onDownloadFile"
                          :value="model.permissionUniqueFile"
                          @input="changePermissionUniqueFile"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="mt-3 mb-3 align-items-center d-flex pr-3">
                <action-button
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger mr-3 pl-3 pr-3"
                  @click="onCancelEdit(model)"
                />
                <action-button
                  :i="'fas ' + (model.id === 0 ? 'fa-file-plus' : 'fa-save')"
                  :text="model.id === 0 ? 'Añadir' : 'Guardar'"
                  variant="success pl-4 pr-4"
                  @click="onSubmit"
                />
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <div
        v-if="!isInEditMode && canChangeLocations()"
        class="text-end pb-3 mr-3"
      >
        <action-button
          i="fas fa-file-plus"
          text="Añadir"
          variant="success pl-4 pr-4"
          @click="initEditMode()"
        />
      </div>
    </div>
    <div
      v-if="!isInEditMode && locations.length > 0"
      class="row justify-content-end"
    >
      <div class="mt-3 mb-3 align-items-center d-flex pr-3">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 pl-3 pr-3"
          @click="handleCancelPanelClick()"
        />
        <action-button
          v-if="canChangeLocations()"
          i="fas fa-flag-alt"
          text="Someter"
          variant="success pl-4 pr-4"
          @click="showAcceptTermsModal = true"
        />
      </div>
    </div>
    <div class="col-12">
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        :save-icon="'fas fa-flag pr-2'"
        save-text="Someter"
        show-cancel
        show-save
        title="Someter"
        :value="showAcceptTermsModal"
        width="850px"
        @cancel="onCancelAcceptTermHandler"
        @save="onSubmitSection"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-acceptedTerms"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          title="Certifico que la información ofrecida es cierta y correcta"
        />
      </custom-modal>
    </div>
    <div v-if="allowPermissionUnique" class="col-12">
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        save-icon="fas fa-flag pr-2"
        save-text="Aceptar"
        show-cancel
        show-save
        title="Certificación"
        :value="showPermissionUniqueAcceptTerms"
        width="850px"
        @cancel="onCancelPermissionUniqueAcceptTerm"
        @save="onSavePermissionUniqueAcceptTerm"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-acceptedTerms"
          v-model="permissionUniqueAcceptTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          title="Certifico que este documento que he subido al Sistema REMPRO es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento. Cualquier alteración, tachadura o modificación indebida en los documentos podrá ser referida a las agencias pertinentes para la toma de acción fiscal y legal correspondiente.(0423)"
        />
      </custom-modal>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import CustomDatePicker from 'custom-date-picker';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import DropDown from 'dropdown';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import {
  getStatesOptions as _getStatesOptions,
  getLocations as _getLocations,
  saveLocation as _saveLocation,
  deleteLocation as _deleteLocation,
} from '@/services/provider/provider-location.api.js';
import { updateStatus as _updateStatus } from '@/services/provider/provider-question.js';
import objectToFormData from 'object-to-formdata';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';
import { getStaticInformation as _getStaticInformation } from '@/services/provider/provider-question.js';
import providerTypes from '@/utils/constants/providerTypes.js';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';

export default {
  name: 'LocationsSection',
  components: {
    TimeLine,
    TimeLineItem,
    IconView,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    CustomCallout,
    CustomFileInput,
    CustomModal,
    CustomCheckboxSingleOption,
    CustomDatePicker,
    DropDown,
  },
  mixins: [alertMixin],
  async mounted() {
    await Promise.all([this.onLoad()]);
  },
  data: () => ({
    readOnly: false,
    model: {
      id: 0,
      addressLine1: null,
      addressLine2: null,
      providerZipCode: null,
      photosFile: null,
      permissionUniqueFile: null,
      permissionUniqueDueDate: null,
    },
    selectedState: null,
    selectedMunicipality: null,
    isInEditMode: false,
    locations: [],
    statesOptions: [],
    municipalityOptions: [],
    showAcceptTermsModal: false,
    acceptedTerms: false,
    permissionUniqueAcceptTerms: false,
    showPermissionUniqueAcceptTerms: false,
    isOpenedPhotoIntExtHistory: false,
    isOpenedPermissionUniqueHistory: false,
  }),
  props: {
    statusId: {
      type: Number,
      default: () => null,
    },
    academicYearId: {
      type: Number,
      default: () => null,
    },
    companyId: {
      type: Number,
      default: () => null,
    },
    providerTypeId: {
      type: Number,
      default: () => null,
    },
    isUniquePermissionDocumentsEnabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    currentDate() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    allowPermissionUnique() {
      return [
        providerTypes.Individual,
        providerTypes.Company,
        providerTypes.DBA,
      ].includes(this.providerTypeId);
    },
    hasLocationToggle() {
      return !this.isInEditMode && this.isUniquePermissionDocumentsEnabled;
    },
  },
  methods: {
    async onLoad() {
      await Promise.all([
        this.getStatesOptions(),
        this.getLocations(this.academicYearId, this.companyId),
        this.getMunicipalities(),
      ]);
      if (!(this.locations.length > 0)) this.isInEditMode = true;
    },
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    async getStatesOptions() {
      const { data: response } = await _getStatesOptions();
      if (response) {
        this.statesOptions = response.map((item) => {
          return { state: item.name, value: item.id, code: item.code };
        });
      }
    },
    async getMunicipalities() {
      this.municipalityOptions = (
        await _getStaticInformation()
      ).data.unitedStatesStateOptions;
    },
    async getLocations(academicYearId, companyId) {
      const { data: response } = await _getLocations(academicYearId, companyId);
      if (response) {
        this.locations = response.map((x) => ({
          ...x,
          isOpened: false,
        }));
      }
    },
    getLocationDescription(location) {
      if (location.municipalityId && location.municipalityId > 0) {
        var municipalityDesc = this.municipalityOptions.find(
          (x) => x.id == location.municipalityId
        );
        if (municipalityDesc) {
          return `${location.addressLine1}, ${location.addressLine2}, ${
            municipalityDesc.name
          }, ${this.getState(location.stateId)}, ${location.providerZipCode}`;
        }
      }
      return `${location.addressLine1}, ${
        location.addressLine2
      }, ${this.getState(location.stateId)}, ${location.providerZipCode}`;
    },
    getState(id) {
      return this.statesOptions.find((state) => state.value == id)?.code;
    },
    isPRSelected() {
      return this.selectedState?.value === 43;
    },
    clearSelectedMunicipality() {
      this.selectedMunicipality = null;
    },
    clean() {
      this.model = { id: 0 };
      this.selectedState = null;
      this.selectedMunicipality = null;
      this.$refs.photoFileUpload?.removeFile();
      this.$refs.permissionUniqueFileUpload?.removeFile();
    },
    initEditMode(item) {
      item = item || { id: 0 };

      this.model.id = item.id;
      this.model.addressLine1 = item.addressLine1;
      this.model.addressLine2 = item.addressLine2;
      this.model.providerZipCode = item.providerZipCode;
      this.model.photosDocument = item.photosDocument;
      this.model.permissionUniqueDocument = item.permissionUniqueDocument;
      this.model.permissionUniqueDueDate = item.permissionUniqueDueDate;

      this.selectedState = this.statesOptions.find(
        (x) => x.value == item.stateId
      );

      this.selectedMunicipality = this.municipalityOptions.find(
        (x) => x.id === item.municipalityId
      );

      this.isInEditMode = true;
    },
    canChangeLocations() {
      return (
        this.statusId === providerProfileStates.Pending ||
        this.statusId === providerProfileStates.Denied ||
        this.statusId === providerProfileStates.ReplacementRequest
      );
    },
    isSubmitted() {
      return (
        this.statusId === providerProfileStates.Submitted ||
        this.statusId === providerProfileStates.Approved
      );
    },
    isDenied() {
      return this.statusId === providerProfileStates.Denied;
    },
    isReplacementRequest() {
      return this.statusId === providerProfileStates.ReplacementRequest;
    },
    onCancelAcceptTermHandler() {
      this.showAcceptTermsModal = false;
      this.acceptedTerms = false;
    },
    async onSubmitSection() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      const payload = {
        sectionId: providerQuestionSection.Location,
        providerId: this.companyId,
        academicYearId: this.academicYearId,
        statusId: providerProfileStates.Submitted,
      };

      const { data: response } = await _updateStatus(payload);

      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-cancel');
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.onCancelAcceptTermHandler();
    },
    async onCancelEdit(item) {
      const answer =
        item.id == 0
          ? await this.ShowCancelModal(
              'Confirmación',
              `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado de esta localidad.`,
              'Sí',
              'No'
            )
          : true;

      if (answer) {
        this.clean();
        this.isInEditMode = !(this.locations.length > 0);
        this.$emit('on-cancel');
      } else {
        return;
      }
    },
    async onDeleteLocation({ id }) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro de que desea eliminar esta localidad?`,
        'Sí',
        'No'
      );

      if (answer) {
        const { data: result } = await _deleteLocation(id).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });

        if (result) {
          await this.reloadLocations();
          this.ShowToast(
            'Proceso Exitoso.',
            'La localidad eliminada exitosamente.',
            'success'
          );
        }
      }
    },
    async onSubmit() {
      const isValid = await this.$refs.locationValidationObserver.validate();
      if (!isValid) return;
      try {
        const payload = {
          ...this.model,
          companyId: this.companyId,
          stateId: this.selectedState?.value,
          municipalityId: this.selectedMunicipality?.id,
          academicYearId: this.academicYearId,
        };

        const dataToSend = objectToFormData(payload, {
          indices: true,
          nullsAsUndefineds: true,
        });

        //TODO handle exception
        await _saveLocation(dataToSend);
        await this.reloadLocations();
      } catch (error) {
        this.ShowToast('Error al guardar información de localidad', 'error');
      }
    },
    async reloadLocations() {
      await this.getLocations(this.academicYearId, this.companyId);
      this.isInEditMode = !(this.locations.length > 0);
      this.clean();
    },
    toggle(item) {
      item.isOpened = !item.isOpened;
    },
    togglePhotoIntExtHistory(isOpened) {
      this.isOpenedPhotoIntExtHistory = !isOpened;
    },
    togglePermissionUniqueDocumentHistory(isOpened) {
      this.isOpenedPermissionUniqueHistory = !isOpened;
    },
    changePhotosFile(val) {
      if (!val) this.model.photosDocument = null;
      this.model.photosFile = val;
    },
    changePermissionUniqueFile(val) {
      if (!val) {
        this.model.permissionUniqueDocument = null;
        this.model.permissionUniqueFile = null;
        return;
      }
      this.model.permissionUniqueFile = val;
      this.showPermissionUniqueAcceptTerms = true;
    },
    onCancelPermissionUniqueAcceptTerm() {
      this.showPermissionUniqueAcceptTerms = false;
      this.permissionUniqueAcceptTerms = false;
      this.$refs.permissionUniqueFileUpload?.removeFile();
    },
    onSavePermissionUniqueAcceptTerm() {
      if (!this.permissionUniqueAcceptTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      this.showPermissionUniqueAcceptTerms = false;
      this.permissionUniqueAcceptTerms = false;
    },
    actionItems(photoInExt, uniquePermission) {
      const items = [];
      if (photoInExt != null) {
        items.push({
          label: 'Fotos Interior y Exterior',
          icon: 'fas fa-file-download color-green  px-2',
          variant: 'outline-success m-2 px-4',
          click: () => this.onDownloadFile(photoInExt),
        });
      }
      if (uniquePermission != null) {
        items.push({
          label: 'Permiso Único',
          icon: 'fas fa-file-download color-green  px-2',
          variant: 'outline-success m-2 px-4',
          click: () => this.onDownloadFile(uniquePermission),
        });
      }

      return items;
    },
    handleCancelPanelClick() {
      if (this.isReplacementRequest()) {
        this.$emit('on-cancel_replacement_panel');
      }
      if (this.isSubmitted()) {
        this.$emit('on-cancel');
      }
      if (this.isDenied()) {
        this.$emit('on-cancel_denied_panel');
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }

  .dot.dot--has-border {
    border-color: transparent !important;
  }

  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}

::v-deep .data-label,
::v-deep .data-name {
  margin-top: 10px;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}

.dot {
  background-color: #ff7058;
  box-shadow: 0 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 31px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}

.title-icon {
  font-size: 1rem;
  color: #fff;
  margin: 5px;
}

.text-end {
  text-align: end;
}

::v-deep .row > .col-sm-6 {
  max-width: 100%;
  flex: 0 0 100%;
}

.dot {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-block;
}
.history-date-title {
  text-align: right;
  margin-bottom: 0px;
  font: 0.75rem Lato;
  letter-spacing: 0px;
  color: black;
}
.history-date-value {
  font: Bold 1rem Lato;
  text-align: right;
  letter-spacing: 0px;
  color: black;
}
.info-field-title {
  font: 0.875rem Lato;
  letter-spacing: 0px;
  margin: 0;
  color: black;
}
.info-field-value {
  font: 1rem Lato;
  letter-spacing: 0px;
  color: black;
  display: block;
}
.header-bg {
  background-color: #ffff;
}
</style>
